import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Smartphone, BellRing } from 'lucide-react';
import { api } from '../lib/api';

const b64ToU8 = (s) => {
  const pad = '='.repeat((4 - (s.length % 4)) % 4);
  const raw = atob((s + pad).replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const PushToggle = () => {
  const supported = typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window;
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!supported) return;
    navigator.serviceWorker.getRegistration('/sw.js').then((r) => r?.pushManager.getSubscription()).then((s) => setOn(!!s)).catch(() => {});
  }, [supported]);

  const enable = async () => {
    setBusy(true);
    try {
      const { data } = await api.get('/push/public-key');
      if (!data.enabled) { toast.error('Push non configuré'); return; }
      const perm = await Notification.requestPermission();
      if (perm !== 'granted') { toast.error('Autorisation refusée dans le navigateur'); return; }
      const reg = await navigator.serviceWorker.register('/sw.js');
      const sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToU8(data.public_key) });
      await api.post('/push/subscribe', { subscription: sub.toJSON() });
      setOn(true);
      await api.post('/push/test');
      toast.success('Notifications activées sur cet appareil');
    } catch (e) { toast.error(e?.response?.data?.detail || 'Impossible d\'activer les notifications'); }
    finally { setBusy(false); }
  };

  const disable = async () => {
    setBusy(true);
    try {
      const reg = await navigator.serviceWorker.getRegistration('/sw.js');
      const sub = await reg?.pushManager.getSubscription();
      if (sub) { await api.delete('/push/subscribe', { params: { endpoint: sub.endpoint } }); await sub.unsubscribe(); }
      setOn(false); toast.success('Notifications désactivées');
    } catch { toast.error('Erreur'); }
    finally { setBusy(false); }
  };

  if (!supported) return <div className="text-xs text-slate-500" data-testid="push-unsupported">Notifications push non prises en charge par ce navigateur.</div>;
  return (
    <button data-testid="push-toggle" disabled={busy} onClick={on ? disable : enable}
      className={`inline-flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-semibold border transition-colors ${on
        ? 'bg-emerald-500/15 border-emerald-500/40 text-emerald-300' : 'border-slate-700 text-slate-200 hover:border-sky-400/60'}`}>
      {on ? <BellRing className="h-4 w-4" /> : <Smartphone className="h-4 w-4" />}
      {on ? 'Notifications téléphone activées' : 'Activer les notifications sur ce téléphone'}
    </button>
  );
};
